import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__booking-pending",
  "use": "icon__booking-pending-usage",
  "viewBox": "-3 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-3 0 24 24\" id=\"icon__booking-pending\"><path d=\"M17 2h-2v5c0 2.485-1.614 4.082-3.192 5 1.578.917 3.192 2.515 3.192 5v5h2a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2h2v-5c0-2.485 1.614-4.083 3.192-5C4.614 11.082 3 9.485 3 7V2H1a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2zM5 17v5h8v-5c0-2.853-3.54-3.947-4.045-4.002C8.999 13.003 5 13.93 5 17zm8-15H5v5c0 3.072 4.004 3.998 4.044 4.002C9.46 10.947 13 9.853 13 7V2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol